<template>
  <div class="renderPage pa-4 pb-16">
    <v-card class="rounded-xl overflow-hidden elevation-24 bg-surface">
      <!-- CABECERA -->
      <div class="pa-6 d-flex align-center bg-slate-gradient white--text">
        <v-icon color="white" large class="mr-4">mdi-truck-delivery-outline</v-icon>
        <div>
          <h2 class="text-h5 font-weight-bold mb-0">Seleccionar Proveedor</h2>
          <span class="caption opacity-80">Busca y selecciona el proveedor para la factura</span>
        </div>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="close()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <!-- CONTENIDO -->
      <v-card-text class="pa-6">
        <div class="d-flex align-center mb-4">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar proveedor..."
            placeholder="Nombre, cédula o código..."
            outlined dense hide-details
            class="flex-grow-1"
            autofocus
          ></v-text-field>
          <v-btn
            color="primary"
            elevation="2"
            class="font-weight-bold ml-4"
            height="40"
            @click="getData()"
            :loading="loading"
          >
            <v-icon left>mdi-refresh</v-icon>
            Refrescar
          </v-btn>
        </div>

        <v-data-table
          :headers="headers"
          :items="items"
          :search="search"
          class="modern-table clickable-rows"
          :items-per-page="10"
          :loading="loading"
          loading-text="Cargando proveedores..."
          @click:row="selected"
        >
          <template v-slot:[`item.codigo`]="{ item }">
            <span class="code-chip">{{ item.codigo }}</span>
          </template>

          <template v-slot:[`item.nombre`]="{ item }">
            <div class="d-flex flex-column py-2">
              <span class="font-weight-bold text-body-1 mb-0">{{ item.nombre }}</span>
              <span class="caption grey--text">{{ item.nombreComercial || '' }}</span>
            </div>
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <v-btn
              color="primary"
              depressed
              class="text-none font-weight-bold px-6"
              @click.stop="selected(item)"
            >
              Seleccionar
            </v-btn>
          </template>

          <template v-slot:no-data>
            <div class="pa-10 text-center">
              <v-icon size="80" color="grey lighten-2" class="mb-4">mdi-truck-outline</v-icon>
              <p class="grey--text text-h6">No hay proveedores registrados</p>
              <v-btn color="primary" text @click="getData()">Reintentar búsqueda</v-btn>
            </div>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";

export default {
  props: {
    allwedOnly: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      search: "",
      loading: false,
      headers: [
        { text: "Código", align: "start", value: "codigo", width: 100 },
        { text: "Proveedor", align: "start", value: "nombre" },
        { text: "Cédula", align: "start", value: "cedula", width: 160 },
        { text: "", value: "actions", width: 140, sortable: false, align: "center" },
      ],
      items: [],
      editedItem: {
        codigo: "", nombre: "", moneda: "", provincia: "", canton: "",
        distrito: "", barrio: "", direccion: "", esReceptor: false,
        correo: "", tipoId: "", nombreComercial: "", areaTel: "",
        telefono: "", cedula: "", cia: "",
      },
    };
  },
  computed: {
    ...mapGetters(["strCia"]),
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      this.loading = true;
      try {
        const res = await axios.get("api/Proveedores/getProveedoresByCompany?cia=" + this.strCia);
        this.items = res.data;
      } catch (e) {
        console.error("Error cargando proveedores:", e);
      } finally {
        this.loading = false;
      }
    },
    selected(item) {
      this.editedItem = Object.assign({}, item);
      this.$emit("clicked", this.editedItem);
    },
    close() {
      this.$emit("closed");
    },
  },
};
</script>

<style scoped>
.bg-slate-gradient {
  background: linear-gradient(135deg, #37474f 0%, #455a64 100%) !important;
}

.modern-table { background: transparent !important; }
.modern-table >>> thead th {
  background-color: #f8fafc !important;
  text-transform: uppercase;
  font-size: 0.75rem !important;
  font-weight: 800 !important;
  color: #475569 !important;
  letter-spacing: 0.05em;
  border-bottom: 2px solid #e2e8f0 !important;
  height: 56px !important;
}
.theme--dark .modern-table >>> thead th {
  background-color: #0f172a !important;
  color: #94a3b8 !important;
  border-bottom: 2px solid #1e293b !important;
}

.clickable-rows >>> tbody tr { cursor: pointer; }
.clickable-rows >>> tbody tr:hover {
  background-color: rgba(55, 71, 79, 0.06) !important;
}

.code-chip {
  font-family: monospace;
  background: #f1f5f9;
  border-radius: 4px;
  padding: 2px 6px;
  font-size: 0.8rem;
  font-weight: 700;
  color: #475569;
}
.theme--dark .code-chip {
  background: #1e293b;
  color: #94a3b8;
}

.opacity-80 { opacity: 0.8; }
</style>